module.exports = __webpack_public_path__ + "static/img/img-xzgt.5316d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/mob/img-xzgt.png
// module id = m8Lf
// module chunks = 0